import { DodSelectOption } from './grafanaBar/GrafanaBar.types';

/**
 * RCP command numbers offered in the "Rozkaz" filter, with their domain names.
 *
 * Names mirror `RcpCommands` in backend/src/core/utils/rcp-orders.constraints.ts, except 17 and 18,
 * which carry the names protocol V2.16 gives them ("Ustaw harmonogram RCP", "Ustaw harmonogram
 * przejścia") rather than the frame keywords the enum is named after (WKD-2513; backend
 * `rcpCommandName`). They are Polish domain terms, not UI copy, so they are not translated: an
 * operator reading a protocol capture sees exactly these words. Commands the enum does not name
 * (00, 16) show as bare numbers rather than an invented label.
 */
export const DOD_COMMAND_NAMES: Record<string, string | undefined> = {
  '00': undefined,
  '02': 'Podaj stan kontrolera',
  '03': 'Pobierz zdarzenia',
  '05': 'Ustaw uprawnienia',
  '06': 'Ustaw uprawnienia zbiorcze',
  '07': 'Kasuj uprawnienia karty',
  '09': 'Ustaw sekwencje',
  '10': 'Usun sekwencje',
  '11': 'Ustaw rewizje',
  '12': 'Ustaw poszukiwany',
  '13': 'Kasuj poszukiwany',
  '14': 'Ustaw komunikat',
  '15': 'Kasuj komunikat',
  '16': undefined,
  '17': 'Ustaw harmonogram RCP',
  '18': 'Ustaw harmonogram przejścia',
  '19': 'Ustaw wyjatek przejscia',
  '20': 'Ustaw harmonogram metody weryfikacji',
  '25': 'Pobierz liste kontrolerow',
  '29': 'Wyczysc bufor pamieci',
};

export const DOD_COMMAND_NUMBERS = Object.keys(DOD_COMMAND_NAMES);

export const dodCommandLabel = (command: string): string => {
  const name = DOD_COMMAND_NAMES[command];

  return name ? `${command} · ${name}` : command;
};

export const DOD_COMMAND_OPTIONS: DodSelectOption[] = DOD_COMMAND_NUMBERS.map((command) => ({
  value: command,
  label: dodCommandLabel(command),
}));
